import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import {
  ChartConfig,
  CustomSkeletonConfig,
  GridConfig,
  ListConfig,
} from "./custom-skeleton-model";

@Component({
  selector: "app-custom-skeleton",
  templateUrl: "./custom-skeleton.component.html",
  styleUrls: ["./custom-skeleton.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CustomSkeletonComponent implements OnInit {
  @Input() customSkeletonConfig: CustomSkeletonConfig;
  defaultConfig: CustomSkeletonConfig;
  chartModel: ChartConfig = {
    data: [90, 80, 70, 60, 50, 40, 30, 20],
    chartHeight: "300px",
  };
  listModel: ListConfig = {
    noOfListItems: 5,
  };
  gridModel: GridConfig = {
    count: {
      row: 4,
      column: 3,
    },
  };
  gridData: {
    row: Array<number>;
    column: Array<number>;
  };

  constructor() {
    this.defaultConfig = new CustomSkeletonConfig();
  }

  /**
   * To create array of given number of elemets
   * to repeat template number of times
   * @param noOfEle  no of elements of an array
   * @returns
   */
  getArrayofIndex(noOfEle: number): number[] {
    return Array(noOfEle)
      .fill(0)
      .map((x, i) => i);
  }

  setData(): void {
    let isdefault = false;
    if (
      !this.customSkeletonConfig.config ||
      this.customSkeletonConfig.defaultConfig
    ) {
      isdefault = true;
    }
    switch (this.customSkeletonConfig.skeletonType) {
      case "list":
        if (!isdefault) {
          this.listModel = this.customSkeletonConfig.config.list;
        }
        this.listModel.listData =
          this.listModel.listData && this.listModel.listData.length !== 0
            ? this.listModel.listData
            : this.getArrayofIndex(this.listModel.noOfListItems);

        /**
         * @todo find alternate solution for inline styles
         */
        this.listModel.styleUl = this.listModel.styleUl
          ? this.listModel.styleUl
          : { border: "none" };
        this.listModel.styleLi = this.listModel.styleLi
          ? this.listModel.styleLi
          : { padding: "0px 15px 0px 15px" };
        break;

      case "grid":
        if (!isdefault) {
          this.gridModel = this.customSkeletonConfig.config.grid;
        }

        this.gridData = {
          row: this.getArrayofIndex(this.gridModel.count.row),
          column: this.getArrayofIndex(this.gridModel.count.column),
        };
        break;

      case "bar-chart":
        if (!isdefault) {
          this.chartModel = this.customSkeletonConfig.config.chart;
        }
        this.chartModel.style.height = this.chartModel.chartHeight;
        break;

      default:
        break;
    }
  }

  ngOnInit(): void {
    this.setData();
    this.customSkeletonConfig = {
      ...this.defaultConfig,
      ...this.customSkeletonConfig,
    };
  }
}
